import { render, staticRenderFns } from "./NotificationCompanyEmployeeDeleted.vue?vue&type=template&id=202e0518&scoped=true&lang=pug&"
import script from "./NotificationCompanyEmployeeDeleted.vue?vue&type=script&lang=js&"
export * from "./NotificationCompanyEmployeeDeleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e0518",
  null
  
)

export default component.exports